<template lang="pug">
  .agv-login-form
    // Idle state - форма входа/регистрации
    .login-signup-form(v-if="stage === 'idle'")
      el-form(ref="form" :model="newCustomer" label-width="85px" label-position="left" :rules="rules"
        @submit.native.prevent="onGetCode"
        :status-icon="!isLoginFound"
        :show-message="false"
        :hide-required-asterisk="true")
        el-form-item(label="Почта" prop="login")
          el-input.cc-login-input(v-model="newCustomer.login"
            @input="throttledOnLoginChange"
            placeholder="flower-power@mail.ru"
            autocomplete="email"
            type="email"
            name="email")
            i.el-icon-success.el-input__icon.icon-check-circle(slot="suffix" v-if="isLoginFound")
        el-button.login-btn.cc-login-btn(v-if="showLoginButton" type="success" @click="onGetCode")
          | Получить код
        // ВРЕМЕННО: скрыто упоминание о телефоне, т.к. теперь отправляем на email
        // TODO: Раскомментировать когда вернем SMS
        // div(style="font-size: 12px; color: grey; text-align: center; margin-top: 12px;")
        //   | на телефон, который вы указали при регистрации
        .signup-form(v-if="showSignupForm")
          el-form-item(label="Имя" prop="first_name")
            el-input.cc-first-name-input(v-model="newCustomer.first_name" placeholder="Анна" name="name" autocomplete="given-name")
          el-form-item(label="Фамилия" prop="last_name")
            el-input.cc-last-name-input(v-model="newCustomer.last_name" placeholder="Кузнецова" autocomplete="family-name")
          el-form-item(label="Телефон" prop="phone")
            el-input.cc-phone-input(v-model="newCustomer.phone" placeholder="89012345678" type="text" autocomplete="tel")
          el-form-item(label="Город")
            el-select.cc-town-select(v-model="newCustomer.town_id" placeholder="Выбрать" filterable style="width: 100%;")
              el-option(:label="town.name" :value="town.id" v-for="town in towns" :key="town.id")
          el-checkbox.cc-is-professional-checkbox(v-model="newCustomer.is_professional" style="margin-bottom: 20px; font-weight: normal;")
            | Я — специалист праздничной сферы
          el-form-item(label="Компания" v-if="newCustomer.is_professional" prop="company_name")
            el-input.cc-company-name-input(v-model="newCustomer.company_name")
          div(v-if="newCustomer.is_professional")
            el-checkbox.cc-is-subscribed-to-newsletter-checkbox(v-model="newCustomer.is_subscribed_to_newsletter" style="margin-bottom: 20px;")
              | Получать новости Пифакита
            .newsletter-description
              | Пишем редко и по делу
          el-button.signup-btn.cc-signup-btn(type="success" @click="onGetCode")
            | Получить код

    // Waiting state - ввод кода
    .otp-wizard(v-if="stage === 'waiting'")
      .delivery-method-active
        .delivery-info
          h3.input-otp-heading
            | Введите код
          // ВРЕМЕННО: скрыт SMS статус, показываем только email
          // TODO: Раскомментировать когда вернем SMS
          // .delivery-title(v-if="sessionStatus === 'sms_pending'")
          //   | отправленный на +7
          //   span.phone-dots &nbsp;•••&nbsp;••&nbsp;••
          //   |  {{ maskedPhone || '' }}
          .delivery-title(v-if="sessionStatus === 'email_pending'")
            | отправленный на {{ newCustomer.login }}

      .otp-input-section
        el-form(ref="otpForm" :model="otpData" @submit.native.prevent="onVerifyCode")
          el-form-item(prop="otp_code")
            .otp-input-wrapper
              .otp-input-container
                el-input.otp-input.cc-otp-input(
                  v-model="otpData.otp_code"
                  placeholder=""
                  maxlength="4"
                  :disabled="isVerifying"
                  ref="otpInput"
                  @input="onOtpInput"
                  autocomplete="one-time-code"
                  type="text"
                  inputmode="numeric"
                )
                .otp-underscores(aria-hidden="true")
                  | ____

          .verification-error(v-if="error")
            span {{ error }}

      .alternative-delivery-section(v-if="!attemptsExceeded")
        // Кнопка "Отправить ещё раз" только для email
        el-button(
          v-if="sentToEmail"
          type="text"
          @click="resendCode"
          :disabled="isResending || !canResendEmail"
          :loading="isResending"
        )
          | {{ resendButtonText }}
        // ВРЕМЕННО: скрыта кнопка "Отправить на e-mail", т.к. теперь сразу отправляем по email
        // TODO: Раскомментировать когда вернем SMS
        // el-button(
        //   v-if="!sentToEmail"
        //   type="text"
        //   @click="sendToEmail"
        //   :disabled="isSendingEmail"
        //   :loading="isSendingEmail"
        // )
        //   | Отправить на e-mail
      
      .new-code-section(v-if="attemptsExceeded")
        el-button(
          type="success"
          @click="requestNewCode"
          :disabled="isResending"
          :loading="isResending"
        )
          | Отправить новый код

</template>

<script>
import Vue from "vue";
import axios from "axios";
import { reachGoal } from "Shared/lib/metrika";
import eventBus from "Shared/eventBus";
import { EMAIL_REGEX } from "Aggregator/shared/validation";

export default {
  name: "agv-login-form",
  data() {
    return {
      stage: 'idle', // 'idle' | 'waiting' | 'authed'
      sessionId: null,
      attemptsLeft: 3,
      error: '',
      attemptsExceeded: false,
      sessionStatus: 'sms_pending', // статус с сервера
      maskedPhone: '', // последние 3 цифры телефона
      lastSendTime: null, // время последней отправки
      resendCountdown: 0, // обратный отсчет в секундах
      countdownInterval: null, // интервал для таймера
      
      triedLogin: false,
      isLoginFound: false,
      isVerifying: false,
      isResending: false,
      isSendingEmail: false,
      
      newCustomer: {
        login: this.$store.state.savedLogin || "",
        town_id: parseInt(this.$store.state.route.params.town_id),
        is_subscribed_to_newsletter: true
      },
      rules: {
        login: [
          { required: true },
          { type: "email", trigger: "blur" }
        ],
        first_name: [
          { required: true }
        ],
        last_name: [
          { required: true }
        ],
        phone: [
          { required: true },
          { type: "string", pattern: /^(8|\+7)?9\d{9}$/, trigger: "blur" }
        ],
        company_name: [
          { required: true }
        ]
      },
      otpData: {
        otp_code: ""
      },
    };
  },
  computed: {
    showLoginButton() {
      return this.triedLogin && this.isLoginFound;
    },
    showSignupForm() {
      return this.triedLogin && !this.isLoginFound;
    },
    throttledOnLoginChange: function() {
      return this.onLoginChange;
    },
    towns() {
      return this.$store.state.town.towns;
    },
    sentToEmail() {
      return this.sessionStatus === 'email_pending';
    },
    canResendEmail() {
      return this.resendCountdown === 0;
    },
    resendButtonText() {
      if (this.resendCountdown > 0) {
        return `Отправить ещё раз (${this.resendCountdown}с)`;
      }
      return 'Отправить ещё раз';
    }
  },
  methods: {
    onGetCode() {
      if (this.showSignupForm) {
        this.signup();
      } else {
        this.startAuth();
      }
    },
    
    signup() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          reachGoal("signup:begin");
          // Сначала регистрируем, если это новый пользователь
          axios.post('/api/aggregator_customer/signup', 
            _.merge(this.newCustomer, {
              is_subscribed_to_newsletter: this.newCustomer.is_subscribed_to_newsletter && this.newCustomer.is_professional
            })
          ).then(() => {
            this.startAuth();
            reachGoal("signup:done");
          }).catch((error) => {
            this.handleError(error);
          });
        }
      });
    },
    
    startAuth() {
      reachGoal("sendLoginEmail:begin");
      
      axios.post('/api/auth/start', { 
        login: this.newCustomer.login.toLowerCase() 
      }).then((response) => {
        this.sessionId = response.data.session_id;
        this.attemptsLeft = response.data.attempts_left;
        this.sessionStatus = response.data.status;
        this.maskedPhone = response.data.masked_phone || '';
        this.stage = 'waiting';
        this.error = '';
        this.attemptsExceeded = false;
        this.stopResendCountdown(); // Сбрасываем таймер при новом коде
        
        // Запускаем таймер сразу после отправки кода по email
        if (this.sessionStatus === 'email_pending') {
          this.startResendCountdown();
        }
        
        Vue.$localStorage.set("login_back_url", this.$route.path);
        
        // Уведомляем родительский компонент что показываем форму ввода кода
        this.$emit('otp-form-shown', true);
        
        this.$nextTick(() => {
          this.focusOtpInput();
        });
        
        reachGoal("sendLoginEmail:done");
      }).catch((error) => {
        this.handleError(error);
      });
    },
    
    onLoginChange() {
      if (!this.newCustomer.login.match(EMAIL_REGEX)) {
        this.isLoginFound = false;
        return;
      }

      axios.get(`/api/aggregator_customer/can_login_with?login=${this.newCustomer.login}`)
        .then(({ data: result }) => {
          this.triedLogin = true;
          this.isLoginFound = result;
        }, () => {
          this.triedLogin = true;
        });
    },

    focusOtpInput() {
      if (this.$refs.otpInput && this.$refs.otpInput.$refs.input) {
        this.$refs.otpInput.$refs.input.focus();
      }
    },
    
    onOtpInput() {
      this.error = "";
      this.otpData.otp_code = this.otpData.otp_code.replace(/\D/g, "");

      if (this.otpData.otp_code.length === 4) {
        this.onVerifyCode();
      }
    },

    onVerifyCode() {
      if (this.isVerifying || this.otpData.otp_code.length !== 4) return;

      this.isVerifying = true;
      this.error = "";

      axios.post("/api/auth/verify", {
        session_id: this.sessionId,
        code: this.otpData.otp_code
      }).then((response) => {
        this.stage = 'authed';
        this.$store.dispatch('customer/load').then(()=>{
          this.$emit('close')
        })
      }).catch((error) => {
        this.isVerifying = false;
        this.handleVerificationError(error);
      });
    },
    
    handleVerificationError(error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorType = error.response.data.error;
        
        switch (errorType) {
          case 'invalid_code':
            this.attemptsLeft = error.response.data.attempts_left || this.attemptsLeft - 1;
            this.error = "Неверный код"
            this.otpData.otp_code = "";
            this.$nextTick(() => {
              this.focusOtpInput();
            });
            break;
          case 'attempts_exceeded':
            this.error = 'Превышено количество попыток';
            this.attemptsExceeded = true;
            this.resetOtpData();
            break;
          case 'code_expired':
            this.error = 'Код истек';
            this.attemptsExceeded = true;
            this.resetOtpData();
            break;
          default:
            this.error = 'Произошла ошибка при проверке кода';
        }
      } else {
        this.error = 'Произошла ошибка при проверке кода';
      }
    },
    
    resendCode() {
      if (this.isResending || !this.sessionId) return;
      
      this.isResending = true;
      this.error = '';
      
      axios.post("/api/auth/resend", {
        session_id: this.sessionId
      }).then((response) => {
        this.isResending = false;
        this.attemptsLeft = response.data.attempts_left;
        this.sessionStatus = response.data.status;
        // Запускаем таймер только если это email повтор
        if (response.data.status === 'email_pending') {
          this.startResendCountdown();
        }
        this.resetOtpData();
        this.$nextTick(() => {
          this.focusOtpInput();
        });
      }).catch((error) => {
        this.isResending = false;
        this.handleResendError(error);
      });
    },
    
    sendToEmail() {
      if (this.isSendingEmail || !this.sessionId) return;
      
      this.isSendingEmail = true;
      this.error = '';
      
      axios.post("/api/auth/email", {
        session_id: this.sessionId
      }).then((response) => {
        this.isSendingEmail = false;
        this.attemptsLeft = response.data.attempts_left;
        this.sessionStatus = response.data.status;
        this.startResendCountdown(); // Запускаем таймер после отправки email
        this.resetOtpData();
        this.$nextTick(() => {
          this.focusOtpInput();
        });
      }).catch((error) => {
        this.isSendingEmail = false;
        this.handleResendError(error);
      });
    },
    
    handleResendError(error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorType = error.response.data.error;
        
        switch (errorType) {
          case 'rate_limit':
            const retryAfter = error.response.data.retry_after;
            this.error = `Слишком частые запросы. Попробуйте через ${retryAfter} секунд`;
            break;
          case 'send_failed':
            this.error = 'Не удалось отправить код. Попробуйте позже';
            break;
          default:
            this.error = 'Произошла ошибка при отправке кода';
        }
      } else {
        this.error = 'Произошла ошибка при отправке кода';
      }
    },
    
    handleError(error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorType = error.response.data.error;
        
        switch (errorType) {
          case 'rate_limit':
            const retryAfter = error.response.data.retry_after;
            this.error = `Слишком частые запросы. Попробуйте через ${retryAfter} секунд`;
            break;
          case 'send_failed':
            this.error = 'Не удалось отправить код. Проверьте подключение к интернету';
            break;
          default:
            this.error = 'Произошла ошибка. Попробуйте позже';
        }
      } else {
        this.error = 'Произошла ошибка. Попробуйте позже';
      }
    },
    
    requestNewCode() {
      // Запрашиваем новый код - по сути это тот же startAuth
      this.startAuth();
    },
    
    resetOtpData() {
      this.otpData.otp_code = "";
    },
    
    startResendCountdown() {
      this.lastSendTime = Date.now();
      this.resendCountdown = 60;
      
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
      
      this.countdownInterval = setInterval(() => {
        const elapsed = Math.floor((Date.now() - this.lastSendTime) / 1000);
        this.resendCountdown = Math.max(0, 60 - elapsed);
        
        if (this.resendCountdown === 0) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        }
      }, 1000);
    },
    
    stopResendCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      this.resendCountdown = 0;
    }
  },
  created() {
    this.onLoginChange();
  },
  beforeDestroy() {
    this.stopResendCountdown();
  }
};
</script>

<style scoped>
.icon-check-circle {
  color: #67C23A;
  top: 1px;
  position: relative;
}

.login-btn, .signup-btn {
  width: 100%;
}

.signup-btn {
  margin-top: 20px;
}

.el-input >>> .el-input__prefix {
  left: 17px;
}

.newsletter-description {
  margin-left: 24px;
  margin-top: -15px;
  margin-bottom: 20px;
  font-size: 13px;
}

.agv-login-form >>> .el-checkbox__label {
  font-weight: normal;
}

.phone-dots {
  letter-spacing: 0.2rem;
  position: relative;
  top: -1px;
}

/* OTP стили */
.otp-wizard {
  padding: 0;
  max-width: 320px;
  margin: 0 auto;
}

.delivery-method-active {
  margin-bottom: 32px;
}

.delivery-title {
  font-size: 15px;
  font-weight: normal;
  color: #606266;
  line-height: 1.5;
  text-align: center;
}

.input-otp-heading {
  font-size: 24px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 16px;
}

.otp-input-section {
  margin-bottom: 24px;
}

.otp-input-section >>> .el-form-item__content {
  display: flex;
  justify-content: center;
}

.alternative-delivery-section {
  text-align: center;
}

.alternative-delivery-section .el-button {
  color: #4990E2;
  font-size: 14px;
  font-weight: normal;
  margin: 5px;
  transition: none;
}

.alternative-delivery-section .el-button.is-disabled {
  color: #c0c4cc !important;
  cursor: not-allowed;
}

.new-code-section {
  text-align: center;
  margin-top: 20px;
}

.new-code-section .el-button {
  width: 100%;
  font-size: 16px;
}

.otp-input-wrapper {
  margin: 0;
  border: 4px solid #eee;
  border-radius: 20px;

  padding: 20px 0 20px 20px;
  width: 184px;
}

.otp-input-container {
  position: relative;
  display: inline-block;
}

.otp-input {
  width: auto;
}

.otp-input >>> .el-input__inner {
  font-family: monospace;
  font-size: 2rem;
  letter-spacing: 1.2rem;
  border: none;
  outline: none;
  background: transparent;
  caret-color: #444;
  color: #000;
  padding: 0;
  height: auto;
  line-height: 1;
}

.otp-input >>> .el-input__inner:focus {
  border: none;
  outline: none;
  box-shadow: none;
}

.otp-input >>> .el-input__inner:disabled {
  background: transparent;
  color: #a0a0a0;
}

.otp-input >>> .el-input__inner::placeholder {
  color: transparent;
}

.otp-underscores {
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0.35em;
  font-family: monospace;
  font-size: 2rem;
  letter-spacing: 1.2rem;
  color: #ccc;
  user-select: none;
}

.verification-error {
  color: #ff944d;
  font-size: 13px;
  text-align: center;
  margin-top: 16px;
  line-height: 1.4;
  font-weight: 500;
}
</style>